import { SelectOption, Topic } from './models/support.interface';

const NETWORK_OPTIONS: SelectOption[] = [
    { value: 'aac_rasff', label: 'AAC/RASFF' },
    { value: 'animal_welfare', label: 'Animal Welfare' },
    { value: 'food_fraud', label: 'Food Fraud' },
    { value: 'pet_animals', label: 'Pet Animals' },
    { value: 'plant_health', label: 'Plant Health' },
];

export const SUPPORT_TOPICS: Topic[] = [
    {
        id: 'eu-login',
        label: 'EU login account',
        labelKey: 'page.support.eu-login.topic',
        categories: [
            {
                id: 'how-to-create-eu-login-account',
                label: 'How to create an EU Login account',
                labelKey: 'page.support.eu-login.how-to-create-eu-login-account.category',
                showWarning: true,
                warning: {
                    titleKey: 'page.support.warning.eu-login.title',
                    contentKey: 'page.support.warning.eu-login.content',
                },
                links: [
                    {
                        url: 'https://trusted-digital-identity.europa.eu/creating-managing-and-using-your-eu-login-account/how-do-i-create-my-eu-login-account_en',
                        labelKey: 'page.support.eu-login.how-to-create-eu-login-account.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'How to create an EU Login account',
                inputs: [
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'text',
                        required: true,
                    },
                ],
            },
            {
                id: 'password-issues',
                label: 'Password issues',
                labelKey: 'page.support.eu-login.password-issues.category',
                showWarning: true,
                warning: {
                    titleKey: 'page.support.warning.eu-login.title',
                    contentKey: 'page.support.warning.eu-login.content',
                },
                links: [
                    {
                        url: 'https://trusted-digital-identity.europa.eu/creating-managing-and-using-your-eu-login-account/how-changereset-my-eu-login-password_en',
                        labelKey:
                            'page.support.eu-login.password-issues.password-issues.how-to-change-reset-password.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'Password issues',
                inputs: [
                    {
                        name: 'Detailed description',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'text',
                        required: true,
                    },
                ],
            },
            {
                id: 'update-account-details',
                label: 'Update account details (phone, email address, name)',
                labelKey:
                    'page.support.eu-login.update-account-details.update-account-details.category',
                showWarning: true,
                warning: {
                    titleKey: 'page.support.warning.eu-login.title',
                    contentKey: 'page.support.warning.eu-login.content',
                },
                links: [
                    {
                        url: 'https://trusted-digital-identity.europa.eu/creating-managing-and-using-your-eu-login-account/managing-your-eu-login-account-options-and-details_en',
                        labelKey:
                            'page.support.eu-login.update-account-details.update-account-details.how-to-manage-account-options-and-details.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'Update account details (phone, email address, name)',
                inputs: [
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'text',
                        required: true,
                    },
                ],
            },
            {
                id: 'two-factor-authentication',
                label: 'Two Factor Authentication',
                labelKey:
                    'page.support.eu-login.two-factor-authentication.two-factor-authentication.category',
                showWarning: true,
                warning: {
                    titleKey: 'page.support.warning.eu-login.title',
                    contentKey: 'page.support.warning.eu-login.content',
                },
                links: [
                    {
                        url: 'https://trusted-digital-identity.europa.eu/creating-managing-and-using-your-eu-login-account/what-second-factor-can-i-configure-my-account_en',
                        labelKey:
                            'page.support.eu-login.two-factor-authentication.two-factor-authentication.what-second-factor-can-i-configure-my-account.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'Two Factor Authentication',
                inputs: [
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'text',
                        required: true,
                    },
                ],
            },
            {
                id: 'other-eu-login-issues',
                label: 'Other EU login issues',
                labelKey:
                    'page.support.eu-login.other-eu-login-issues.other-eu-login-issues.category',
                showWarning: true,
                warning: {
                    titleKey: 'page.support.warning.eu-login.title',
                    contentKey: 'page.support.warning.eu-login.content',
                },
                links: [
                    {
                        url: 'https://trusted-digital-identity.europa.eu/creating-managing-and-using-your-eu-login-account_en',
                        labelKey:
                            'page.support.eu-login.other-eu-login-issues.other-eu-login-issues.creating-managing-and-using-your-eu-login-account.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'Other EU login issues',
                inputs: [
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'text',
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        id: 'irasff-access',
        label: 'iRASFF Access',
        labelKey: 'page.support.irasff-access.topic',
        categories: [
            {
                id: 'how-to-access-irasff',
                label: 'How to Access iRASFF',
                labelKey: 'page.support.irasff-access.how-to-access-irasff.category',
                links: [
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/irasff/help/en/getting-started.html',
                        labelKey:
                            'page.support.irasff-access.how-to-access-irasff.getting-started-guide.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'How to Access iRASFF',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'network',
                        label: 'Network',
                        labelKey: 'page.support.network.input',
                        placeholderKey: 'page.support.network.placeholder',
                        type: 'select',
                        required: false,
                        options: NETWORK_OPTIONS,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                        maxLength: 4000,
                    },
                ],
            },
            {
                id: 'access-denied-no-network',
                label: 'Access denied: No network assigned in SAAS',
                labelKey: 'page.support.irasff-access.access-denied-no-network.category',
                links: [
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/irasff/help/en/getting-started.html',
                        labelKey:
                            'page.support.irasff-access.access-denied-no-network.getting-started-guide.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'No Network assigned',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'network',
                        label: 'Network',
                        labelKey: 'page.support.network.input',
                        placeholderKey: 'page.support.network.placeholder',
                        type: 'select',
                        required: false,
                        options: NETWORK_OPTIONS,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'who-can-validate-access-request',
                label: 'Who can validate access request?',
                labelKey: 'page.support.irasff-access.who-can-validate-access-request.category',
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'iRASFF Pending Access Request ',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'network',
                        label: 'Network',
                        labelKey: 'page.support.network.input',
                        placeholderKey: 'page.support.network.placeholder',
                        type: 'select',
                        required: false,
                        options: NETWORK_OPTIONS,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'account-locked-in-saas',
                label: 'Account locked in SAAS',
                labelKey: 'page.support.irasff-access.account-locked-in-saas.category',
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'iRASFF Account Lock',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'network',
                        label: 'Network',
                        labelKey: 'page.support.network.input',
                        placeholderKey: 'page.support.network.placeholder',
                        type: 'select',
                        required: false,
                        options: NETWORK_OPTIONS,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'how-to-manage-users',
                label: 'How to manage users (validation, rejection, updates)',
                labelKey:
                    'page.support.irasff-access.how-to-manage-users.how-to-manage-users.category',
                links: [
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/irasff/help/en/guidance.html',
                        labelKey:
                            'page.support.irasff-access.how-to-manage-users.how-to-manage-users.guidance-for-local-administrators.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'User management for Local Administrator',
                inputs: [
                    {
                        name: 'requestType',
                        label: 'Request Type',
                        labelKey:
                            'page.support.irasff-access.how-to-manage-users.how-to-manage-users.request-type.input',
                        type: 'select',
                        required: true,
                        options: [
                            {
                                value: 'validation',
                                label: 'Validation',
                                labelKey:
                                    'page.support.irasff-access.requestType.option.validation',
                            },
                            {
                                value: 'rejection',
                                label: 'Rejection',
                                labelKey: 'page.support.irasff-access.requestType.option.rejection',
                            },
                            {
                                value: 'updates',
                                label: 'Updates',
                                labelKey: 'page.support.irasff-access.requestType.option.updates',
                            },
                            {
                                value: 'lock',
                                label: 'Lock/Unlock user',
                                labelKey: 'page.support.irasff-access.requestType.option.lock',
                            },
                            {
                                value: 'delete',
                                label: 'Delete',
                                labelKey: 'page.support.irasff-access.requestType.option.delete',
                            },
                            {
                                value: 'editProfile',
                                label: 'Edit profile',
                                labelKey:
                                    'page.support.irasff-access.requestType.option.editProfile',
                            },
                            {
                                value: 'networkManagement',
                                label: 'Network management',
                                labelKey:
                                    'page.support.irasff-access.requestType.option.networkManagement',
                            },
                            {
                                value: 'mailboxProfile',
                                label: 'Mailbox profile',
                                labelKey:
                                    'page.support.irasff-access.requestType.option.mailboxProfile',
                            },
                            {
                                value: 'organisationManagement',
                                label: 'Organisation management',
                                labelKey:
                                    'page.support.irasff-access.requestType.option.organisationManagement',
                            },
                            {
                                value: 'translationModule',
                                label: 'Translation module',
                                labelKey:
                                    'page.support.irasff-access.requestType.option.translationModule',
                            },
                        ],
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'other-access-issues',
                label: 'Other Access issues',
                labelKey:
                    'page.support.irasff-access.other-access-issues.other-access-issues.category',
                impact: '2',
                urgency: '2',
                category: 'incident',
                short_description: 'iRASFF - Other Access request',
                inputs: [
                    {
                        name: 'file',
                        label: 'Screenshot of the error message displayed',
                        labelKey: 'page.support.file.input',
                        type: 'file',
                        required: false,
                    },
                    {
                        name: 'timestamp',
                        label: 'Timestamp',
                        labelKey: 'page.support.timestamp.input',
                        placeholderKey: 'page.support.timestamp.placeholder',
                        type: 'date',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        id: 'rasff-window-access',
        label: 'RASFF Window Access',
        labelKey: 'page.support.rasff-window-access.topic',
        categories: [
            {
                id: 'how-to-access-rasff-window',
                label: 'How to Access RASFF Window',
                labelKey: 'page.support.rasff-window-access.how-to-access-rasff-window.category',
                links: [
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/rasff-window-help/en/registered-users-access/registration.html',
                        labelKey:
                            'page.support.rasff-window-access.how-to-access-rasff-window.registration-guide.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'How to Access RASFF Window',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'who-can-validate-access-request',
                label: 'Who can validate access request?',
                labelKey:
                    'page.support.rasff-window-access.who-can-validate-access-request.category',
                links: [
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/rasff-window-help/en/registered-users-access/registration.html',
                        labelKey:
                            'page.support.rasff-window-access.who-can-validate-access-request.registration-guide.link',
                    },
                ],
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'RASFF Window  Pending Access Request ',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'account-locked',
                label: 'Account locked',
                labelKey: 'page.support.rasff-window-access.account-locked.category',
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'RASFF Window Account Lock',
                inputs: [
                    {
                        name: 'country',
                        label: 'Country',
                        labelKey: 'page.support.country.input',
                        placeholderKey: 'page.support.country.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'organisation',
                        label: 'Organisation',
                        labelKey: 'page.support.organisation.input',
                        placeholderKey: 'page.support.organisation.placeholder',
                        type: 'text',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'other-access-issues',
                label: 'Other Access issues',
                labelKey: 'page.support.rasff-window-access.other-access-issues.category',
                impact: '2',
                urgency: '2',
                category: 'incident',
                short_description: 'RASFF Window - Other Access request',
                inputs: [
                    {
                        name: 'file',
                        label: 'Screenshot of the error message displayed',
                        labelKey: 'page.support.file.input',
                        type: 'file',
                        required: false,
                    },
                    {
                        name: 'timestamp',
                        label: 'Timestamp',
                        labelKey: 'page.support.timestamp.input',
                        placeholderKey: 'page.support.timestamp.placeholder',
                        type: 'date',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detailed description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        id: 'irasff-application',
        label: 'iRASFF Application',
        labelKey: 'page.support.irasff-application.topic',
        categories: [
            {
                id: 'request-question',
                label: 'Request / Question',
                labelKey: 'page.support.irasff-application.request-question.category',
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'iRASFF  Application  - Request / Question',
                links: [
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/irasff/help/en/irasff-application.html',
                        labelKey:
                            'page.support.irasff-application.request-question.irasff-application-guide.link',
                    },
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/irasff/help/en/vs.html',
                        labelKey:
                            'page.support.irasff-application.request-question.visual-structure-of-notification.link',
                    },
                    {
                        url: 'https://webgate.ec.europa.eu/imsoc-guide/irasff/help/en/d.html',
                        labelKey:
                            'page.support.irasff-application.request-question.the-dashboard.link',
                    },
                ],
                inputs: [
                    {
                        name: 'summary',
                        label: 'Summary of the request',
                        labelKey: 'page.support.summary.input',
                        placeholderKey: 'page.support.summary-request.placeholder',
                        type: 'text',
                        required: true,
                        maxLength: 160,
                    },
                    {
                        name: 'network',
                        label: 'Network',
                        labelKey: 'page.support.network.input',
                        placeholderKey: 'page.support.network.placeholder',
                        type: 'select',
                        required: false,
                        options: NETWORK_OPTIONS,
                    },
                    {
                        name: 'notificationReference',
                        label: 'Notification reference',
                        labelKey: 'page.support.notification-reference.input',
                        placeholderKey: 'page.support.notification-reference.placeholder',
                        type: 'text',
                        required: false,
                        maxLength: 160,
                    },
                    {
                        name: 'file',
                        label: 'Screenshot or relevant document',
                        labelKey: 'page.support.file.input',
                        type: 'file',
                        required: false,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detail description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: false,
                    },
                ],
            },
            {
                id: 'incident-issue',
                label: 'Incident / Issue',
                labelKey: 'page.support.irasff-application.incident-issue.category',
                impact: '2',
                urgency: '2',
                category: 'incident',
                short_description: 'iRASFF  Application - Incident / Issue',
                inputs: [
                    {
                        name: 'summary',
                        label: 'Error message / Summary of the issue',
                        labelKey: 'page.support.error-summary.input',
                        placeholderKey: 'page.support.error-summary-issues.placeholder',
                        type: 'text',
                        required: true,
                        maxLength: 160,
                    },
                    {
                        name: 'network',
                        label: 'Network',
                        labelKey: 'page.support.network.input',
                        placeholderKey: 'page.support.network.placeholder',
                        type: 'select',
                        required: false,
                        options: NETWORK_OPTIONS,
                    },
                    {
                        name: 'notificationReference',
                        label: 'Notification reference',
                        labelKey: 'page.support.notification-reference.input',
                        placeholderKey: 'page.support.notification-reference.placeholder',
                        type: 'text',
                        required: false,
                        maxLength: 160,
                    },
                    {
                        name: 'file',
                        label: 'Screenshot or relevant document',
                        labelKey: 'page.support.file.input',
                        type: 'file',
                        required: false,
                    },
                    {
                        name: 'timestamp',
                        label: 'Timestamp',
                        labelKey: 'page.support.timestamp.input',
                        placeholderKey: 'page.support.timestamp.placeholder',
                        type: 'date',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detail description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description-last-action.placeholder',
                        type: 'textarea',
                        required: false,
                    },
                ],
            },
        ],
    },
    {
        id: 'rasff-window-application',
        label: 'RASFF Window Application',
        labelKey: 'page.support.rasff-window-application.topic',
        categories: [
            {
                id: 'request-question',
                label: 'Request / Question',
                labelKey: 'page.support.rasff-window-application.request-question.category',
                impact: '3',
                urgency: '3',
                category: 'inquiry',
                short_description: 'RASFF Window  Application  - Request / Question',
                inputs: [
                    {
                        name: 'summary',
                        label: 'Summary of the request',
                        labelKey: 'page.support.summary.input',
                        placeholderKey: 'page.support.summary-request.placeholder',
                        type: 'text',
                        required: true,
                        maxLength: 160,
                    },
                    {
                        name: 'reference',
                        label: 'Reference',
                        labelKey: 'page.support.reference.input',
                        placeholderKey: 'page.support.reference.placeholder',
                        type: 'text',
                        required: false,
                        maxLength: 160,
                    },
                    {
                        name: 'file',
                        label: 'Screenshot or relevant document',
                        labelKey: 'page.support.file.input',
                        type: 'file',
                        required: false,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detail description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description.placeholder',
                        type: 'textarea',
                        required: true,
                    },
                ],
            },
            {
                id: 'incident-issue',
                label: 'Incident / Issue',
                labelKey: 'page.support.rasff-window-application.incident-issue.category',
                impact: '2',
                urgency: '2',
                category: 'incident',
                short_description: 'RASFF Window  Application - Incident / Issue',
                inputs: [
                    {
                        name: 'summary',
                        label: 'Error message / Summary of the issue',
                        labelKey: 'page.support.error-summary.input',
                        placeholderKey: 'page.support.error-summary-issues.placeholder',
                        type: 'text',
                        required: true,
                        maxLength: 160,
                    },
                    {
                        name: 'reference',
                        label: 'Reference',
                        labelKey: 'page.support.reference.input',
                        placeholderKey: 'page.support.reference.placeholder',
                        type: 'text',
                        required: false,
                        maxLength: 160,
                    },
                    {
                        name: 'file',
                        label: 'Screenshot or relevant document',
                        labelKey: 'page.support.file.input',
                        type: 'file',
                        required: false,
                    },
                    {
                        name: 'timestamp',
                        label: 'Timestamp',
                        labelKey: 'page.support.timestamp.input',
                        placeholderKey: 'page.support.timestamp.placeholder',
                        type: 'date',
                        required: true,
                    },
                    {
                        name: 'detailedDescription',
                        label: 'Detail description',
                        labelKey: 'page.support.detailed-description.input',
                        placeholderKey: 'page.support.detailed-description-last-action.placeholder',
                        type: 'textarea',
                        required: false,
                    },
                ],
            },
        ],
    },
];
